import { createSvgIcon } from '@mui/material'

export const RailTrackIcon = createSvgIcon(
  <svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_712_41989)'>
      <path
        d='M6.3641 13.4347H27.5773M8.48542 11.3134V22.6271M12.7281 11.3134V22.6271M16.9707 11.3134V22.6271M21.2133 11.3134V22.6271M25.456 11.3134V22.6271M6.3641 20.5058H27.5773'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_712_41989'>
        <rect width='24' height='24' fill='white' transform='translate(16.9707) rotate(45)' />
      </clipPath>
    </defs>
  </svg>,
  'RailTrackIcon',
)
